import React, { useState } from 'react';
import { useEmailApi } from '../../../../hooks/useEmailApi';
import EmailResult from './EmailResult';
import { Loading } from '../../../common/Loading';
import { ErrorAlert } from '../../../common/ErrorAlert';

const EmailWriter = () => {
  const { loading, error, result, generateEmail, clearError } = useEmailApi();
  const [formData, setFormData] = useState({
    type: 'business',
    purpose: 'request',
    tone: 'formal',
    recipient: '',
    subject: '',
    content: '',
    additionalInfo: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    clearError();
    
    try {
      await generateEmail(formData);
    } catch (error) {
      console.error('이메일 생성 오류:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="max-w-4xl mx-auto p-4">
      <h2 className="text-2xl font-bold mb-6">이메일 작성 도우미</h2>
      
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* 이메일 유형 */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            이메일 유형
          </label>
          <select
            name="type"
            className="w-full border border-gray-300 rounded-md px-3 py-2"
            value={formData.type}
            onChange={handleInputChange}
          >
            <option value="business">업무</option>
            <option value="personal">개인</option>
            <option value="academic">학술</option>
            <option value="marketing">마케팅</option>
          </select>
        </div>

        {/* 이메일 목적 */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            이메일 목적
          </label>
          <select
            name="purpose"
            className="w-full border border-gray-300 rounded-md px-3 py-2"
            value={formData.purpose}
            onChange={handleInputChange}
          >
            <option value="request">요청</option>
            <option value="report">보고</option>
            <option value="inquiry">문의</option>
            <option value="proposal">제안</option>
            <option value="notice">공지</option>
          </select>
        </div>

        {/* 어조 */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            어조
          </label>
          <select
            name="tone"
            className="w-full border border-gray-300 rounded-md px-3 py-2"
            value={formData.tone}
            onChange={handleInputChange}
          >
            <option value="formal">격식체</option>
            <option value="casual">일상체</option>
            <option value="friendly">친근체</option>
          </select>
        </div>

        {/* 수신자 */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            수신자
          </label>
          <input
            type="text"
            name="recipient"
            className="w-full border border-gray-300 rounded-md px-3 py-2"
            value={formData.recipient}
            onChange={handleInputChange}
            placeholder="예: 팀장님, 교수님, 고객님"
            required
          />
        </div>

        {/* 제목 */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            제목
          </label>
          <input
            type="text"
            name="subject"
            className="w-full border border-gray-300 rounded-md px-3 py-2"
            value={formData.subject}
            onChange={handleInputChange}
            placeholder="이메일 제목을 입력하세요"
            required
          />
        </div>

        {/* 주요 내용 */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            주요 내용
          </label>
          <textarea
            name="content"
            className="w-full border border-gray-300 rounded-md px-3 py-2 h-32"
            value={formData.content}
            onChange={handleInputChange}
            placeholder="전달하고 싶은 주요 내용을 입력하세요"
            required
          />
        </div>

        {/* 추가 정보 */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            추가 정보 (선택사항)
          </label>
          <textarea
            name="additionalInfo"
            className="w-full border border-gray-300 rounded-md px-3 py-2 h-24"
            value={formData.additionalInfo}
            onChange={handleInputChange}
            placeholder="추가로 포함하고 싶은 정보를 입력하세요"
          />
        </div>

        {/* 제출 버튼 */}
        <button
          type="submit"
          className="w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 disabled:bg-gray-400"
          disabled={loading}
        >
          {loading ? '이메일 생성 중...' : '이메일 생성하기'}
        </button>
      </form>

      {/* 로딩 표시 */}
      {loading && <Loading />}

      {/* 에러 메시지 */}
      {error && <ErrorAlert error={error} onRetry={() => clearError()} />}

      {/* 결과 표시 */}
      {result && <EmailResult result={result} />}
    </div>
  );
};

export default EmailWriter; 